var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _path5, _path6, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainPointHipGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.28,
    height: 78.285,
    viewBox: "0 0 72.28 78.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4653",
    "data-name": "Rectangle 4653",
    width: 72.28,
    height: 78.285,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4642",
    "data-name": "Rectangle 4642",
    width: 30.167,
    height: 48.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4641",
    "data-name": "Rectangle 4641",
    width: 20.735,
    height: 33.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4643",
    "data-name": "Rectangle 4643",
    width: 34.619,
    height: 54.897,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 28.222,
    height: 43.793,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4645",
    "data-name": "Rectangle 4645",
    width: 17.921,
    height: 28.674,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4646",
    "data-name": "Rectangle 4646",
    width: 14.543,
    height: 23.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4647",
    "data-name": "Rectangle 4647",
    width: 9.671,
    height: 5.908,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4648",
    "data-name": "Rectangle 4648",
    width: 15.002,
    height: 12.252,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4649",
    "data-name": "Rectangle 4649",
    width: 4.515,
    height: 7.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4650",
    "data-name": "Rectangle 4650",
    width: 13.586,
    height: 8.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4651",
    "data-name": "Rectangle 4651",
    width: 14.242,
    height: 11.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4652",
    "data-name": "Rectangle 4652",
    width: 14.832,
    height: 10.538,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8247",
    "data-name": "Path 8247",
    d: "M230.046,143.552a39.136,39.136,0,0,0-7.99-23.758c-7.541,5.057-18.3,4.718-27.089-.035-.132,2.507-1.3,4.41-2.615,6.666-2.019,3.466-10.332,10.29-11.026,14.709-2.033,12.936.978,24.487,5.008,41.481a39.754,39.754,0,0,0,4.4.244,39.308,39.308,0,0,0,39.308-39.308",
    transform: "translate(-157.766 -104.575)",
    fill: "#221e3f",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8248",
    "data-name": "Path 8248",
    d: "M226.948,28.166a27.806,27.806,0,0,0,4.768-3.847A39.352,39.352,0,0,0,200.359,0a38.657,38.657,0,0,1,.028,4.938c-.13,2.475-.109,4.452-1.461,6.641-6.249,10.11-14.529,16.64-12.9,19.485,2.1,3.658,16.079,1.877,24.21.659,7.87-1.179,12.333-1.5,16.709-3.557",
    transform: "translate(-162.26 0)",
    fill: "#b1d34a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4940",
    "data-name": "Group 4940",
    transform: "translate(11.08 15.184)",
    opacity: 0.51,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4934",
    "data-name": "Group 4934",
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4932",
    "data-name": "Group 4932",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8249",
    "data-name": "Path 8249",
    d: "M90.63,126.293c-5.159,9.12-4.04,24.394,2.5,34.114s16.024,10.207,21.184,1.086,4.04-24.394-2.5-34.114-16.024-10.207-21.184-1.086",
    transform: "translate(-87.388 -119.759)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937",
    transform: "translate(4.163 7.233)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8250",
    "data-name": "Path 8250",
    d: "M122.452,181.3c-3.546,6.269-2.777,16.767,1.719,23.448s11.014,7.015,14.56.747,2.777-16.767-1.719-23.448-11.014-7.015-14.56-.747",
    transform: "translate(-120.224 -176.809)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8251",
    "data-name": "Path 8251",
    d: "M142.795,217c-2.492,4.4-1.951,11.781,1.208,16.476s7.739,4.929,10.231.525,1.951-11.781-1.208-16.476-7.739-4.929-10.231-.525",
    transform: "translate(-134.403 -201.913)",
    fill: "#ff3131",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943",
    transform: "translate(9.626 12.295)",
    opacity: 0.39,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4942",
    "data-name": "Group 4942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8252",
    "data-name": "Path 8252",
    d: "M96.5,151.867l-.054-.78a9.878,9.878,0,0,0,2.9-.654l.284.728a10.655,10.655,0,0,1-3.134.705m-2.144-.064a12.342,12.342,0,0,1-3.091-.827l.3-.724a11.565,11.565,0,0,0,2.895.776Zm7.191-1.6-.414-.663a12.765,12.765,0,0,0,2.337-1.893l.558.548a13.555,13.555,0,0,1-2.481,2.009m-12.186-.171a17.888,17.888,0,0,1-2.573-1.857l.51-.592a17.091,17.091,0,0,0,2.46,1.776Zm-4.1-3.312A25.79,25.79,0,0,1,83.23,144.3l.627-.466a25,25,0,0,0,1.966,2.342Zm20.151-.133-.623-.472a19.2,19.2,0,0,0,1.392-2.13q.123-.217.241-.438l.689.369q-.123.229-.25.454a20.02,20.02,0,0,1-1.45,2.217m-23.37-4.01c-.553-.863-1.08-1.781-1.566-2.727l.7-.358c.476.924.99,1.82,1.53,2.663Zm25.98-.559-.719-.308a27.176,27.176,0,0,0,1.04-2.88l.749.225a27.927,27.927,0,0,1-1.07,2.964m-28.451-4.058c-.417-.939-.807-1.921-1.158-2.918l.737-.26c.344.978.726,1.94,1.135,2.86Zm30.055-.934-.762-.174c.223-.974.407-1.991.548-3.023l.775.106c-.144,1.055-.333,2.1-.561,3.092m-31.858-3.974c-.294-.991-.558-2.012-.784-3.037l.764-.168c.222,1.006.481,2.009.77,2.982Zm32.645-1.2-.779-.064c.082-1.007.127-2.041.132-3.075l.782,0c-.006,1.053-.051,2.108-.135,3.134m-33.831-3.889c-.177-1.026-.319-2.071-.424-3.106l.778-.079c.1,1.017.243,2.044.417,3.053Zm33.146-1.3c-.043-1.018-.124-2.051-.239-3.071l.777-.088c.117,1.038.2,2.089.243,3.126Zm-33.733-3.889c-.043-.794-.066-1.6-.066-2.383q0-.376.007-.751l.782.014q-.006.368-.006.737c0,.773.022,1.561.064,2.341Zm33.216-1.218c-.162-1.013-.362-2.031-.592-3.023l.762-.177c.235,1.01.438,2.045.6,3.077ZM76.8,117.6l-.78-.053c.072-1.057.186-2.107.339-3.121l.773.116c-.15.993-.261,2.022-.332,3.058m31.3-1.059c-.282-.994-.6-1.979-.949-2.929l.734-.269c.355.968.68,1.972.967,2.985Zm-30.6-4.014-.765-.162c.222-1.046.491-2.07.8-3.042l.745.237c-.3.947-.565,1.946-.781,2.967m28.9-.823c-.408-.955-.855-1.888-1.327-2.773l.69-.368c.483.905.939,1.859,1.357,2.834ZM78.97,107.636l-.725-.293a24.264,24.264,0,0,1,1.366-2.846l.011-.019.677.391-.005.009a23.487,23.487,0,0,0-1.323,2.757m25.078-.485c-.214-.347-.436-.692-.66-1.025-.349-.519-.713-1.023-1.08-1.5l.619-.478c.378.489.751,1.007,1.11,1.54.23.342.458.7.677,1.051Zm-22.659-4-.637-.454a16.547,16.547,0,0,1,2.076-2.406l.538.568a15.764,15.764,0,0,0-1.977,2.292M101,103.064a20.852,20.852,0,0,0-2.207-2.1l.494-.606a21.629,21.629,0,0,1,2.291,2.18Zm-3.847-3.288a13.966,13.966,0,0,0-2.7-1.343l.267-.735a14.735,14.735,0,0,1,2.853,1.418ZM84.927,99.6l-.442-.645a11.533,11.533,0,0,1,2.866-1.436l.247.742a10.753,10.753,0,0,0-2.672,1.34m7.592-1.685a10.187,10.187,0,0,0-2.98-.09l-.093-.776a10.976,10.976,0,0,1,3.209.1Z",
    transform: "translate(-75.925 -96.97)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946",
    transform: "translate(11.928 17.643)",
    opacity: 0.48,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4945",
    "data-name": "Group 4945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4944",
    "data-name": "Group 4944",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8253",
    "data-name": "Path 8253",
    d: "M99.182,175.876c-5.827-8.662-6.811-22.35-2.193-30.515,2.186-3.864,5.353-6.068,8.92-6.206,4.049-.157,8.163,2.417,11.286,7.058,5.828,8.662,6.812,22.351,2.194,30.516-2.186,3.864-5.353,6.067-8.92,6.206a10.309,10.309,0,0,1-5.489-1.431,17.71,17.71,0,0,1-5.8-5.628M106,141.555c-2.7.1-5.163,1.876-6.924,4.989-4.216,7.452-3.275,20.01,2.1,27.992,2.647,3.936,6,6.123,9.2,6,2.7-.105,5.162-1.877,6.923-4.989,4.216-7.452,3.276-20.01-2.1-27.993a15.337,15.337,0,0,0-4.98-4.88,7.944,7.944,0,0,0-4.22-1.12",
    transform: "translate(-94.078 -139.148)",
    fill: "#ff3131"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4949",
    "data-name": "Group 4949",
    transform: "translate(16.65 24.669)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4948",
    "data-name": "Group 4948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M133.248,198.448c-3.065,5.418-2.4,14.491,1.485,20.265s9.519,6.063,12.584.645,2.4-14.491-1.485-20.265-9.519-6.063-12.584-.645",
    transform: "translate(-131.322 -194.567)",
    fill: "#ff3131",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952",
    transform: "translate(18.21 27.299)",
    opacity: 0.57,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M145.188,218.454c-2.487,4.4-1.947,11.76,1.205,16.445s7.725,4.92,10.212.524,1.947-11.76-1.205-16.445-7.725-4.92-10.212-.524",
    transform: "translate(-143.625 -215.304)",
    fill: "#ff3131",
    fillRule: "evenodd"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8256",
    "data-name": "Path 8256",
    d: "M156.739,241.954c-1.747,3.089-1.368,8.263.847,11.555s5.428,3.457,7.176.368,1.368-8.263-.847-11.555-5.428-3.457-7.175-.368",
    transform: "translate(-135.907 -209.344)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8257",
    "data-name": "Path 8257",
    d: "M181.418,163.1c.019-.006,2.689-1.581,2.708-1.587l2.106-10.441,1.047-2.382,5.14-1.143-.71-2.02-1.847-.783-7.938-5.2-5.9,4.72,1.3,6.015-.093,4.818c-.675,2.18,4.192,8.007,4.192,8.007",
    transform: "translate(-153.703 -121.846)",
    fill: "#fbb686",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8258",
    "data-name": "Path 8258",
    d: "M459.665,164.788l4.375-1.164,3.453-3.641.257-.407A39.088,39.088,0,0,0,464.025,151l-2.387.927-1.471,1.737-.781.667.683,1.429,1.57-1.07.971-.55-2.865,2.862-4.433,1.653.178,1.559,3.536-.472-1.8.606-2.458.59.338,1.366,1.966.147,2.2-.511-.379.217-2.432,1.214.723.988,1.713-.279Z",
    transform: "translate(-397.107 -131.858)",
    fill: "#fbb686",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8259",
    "data-name": "Path 8259",
    d: "M101.137,34.435l5.9-4.72L99.15,13.768A39.149,39.149,0,0,0,90.264,18.1Z",
    transform: "translate(-78.819 -12.022)",
    fill: "#fbb686",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955",
    transform: "translate(8.75 43.275)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8260",
    "data-name": "Path 8260",
    d: "M75.6,346.618l-.736-2.537-4.048,3.139-1.8-4.58,5.847-1.328.736,2.154,3.089-1.53Z",
    transform: "translate(-69.016 -341.312)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958",
    transform: "translate(1.249 17.307)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8261",
    "data-name": "Path 8261",
    d: "M24.856,148.751l-7.8-4.677v-3.029L9.854,136.5l7.5,2.155,1.1,4.747Z",
    transform: "translate(-9.854 -136.499)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961",
    transform: "translate(32.861 18.649)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8262",
    "data-name": "Path 8262",
    d: "M263.324,147.089l-3.41,2.8,1.653,2.04-2.39,3.1,4.515-1.73-2.468-2.966Z",
    transform: "translate(-259.177 -147.089)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(0 26.178)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8263",
    "data-name": "Path 8263",
    d: "M13.586,214.152l-6.57.612-1-3.4L0,209.306v-2.84l8.352,3.063-.668,3.452Z",
    transform: "translate(0 -206.466)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967",
    transform: "translate(40.318 46.229)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8264",
    "data-name": "Path 8264",
    d: "M317.991,364.611l5.7,7.571,2.386-2.7,6.159,6.228v-4.947l-7.8-5.548-1.049,3.973Z",
    transform: "translate(-317.991 -364.611)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970",
    transform: "translate(46.344 32.663)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8265",
    "data-name": "Path 8265",
    d: "M365.521,264.655l6.41-.841,1.076,4.339,7.346-3.522-5.753-.022-2.7-6.993Z",
    transform: "translate(-365.521 -257.614)",
    fill: "#ff3131"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPointHipGreen);
export default __webpack_public_path__ + "static/media/painPointHipGreen.227aa9a00a16f448f3599ae045b4dcf8.svg";
export { ForwardRef as ReactComponent };